import {isNil, isNotEmpty} from 'ramda';

import {Nullish} from 'shared/web';

import {Option} from '../types/VehicleCatalogueLogic';

interface CreateVehicleTitleProps {
  formMake: string | Nullish;
  formModel: string | Nullish;
  variant?: string | Nullish;
  /** Group of makes where to find make name. Usually combined with useVehicleMake() hook */
  flatMakes: Option[];
  /** Group of models where to find model name. Usually combined with useVehicleModel() hook */
  flatModels: Option[];
}

export function getVehicleMakeModelNames(props: CreateVehicleTitleProps) {
  const makeName =
    props.flatMakes.find((item) => item.value === props.formMake)?.label || props.formMake || null;

  const modelName =
    props.flatModels.find((item) => item.value === props.formModel)?.label ||
    props.formModel ||
    null;

  return {makeName, modelName};
}

export function createVehicleTitle(props: CreateVehicleTitleProps) {
  const {makeName, modelName} = getVehicleMakeModelNames(props);

  if (!makeName) {
    return null;
  }

  return [makeName, modelName, props.variant]
    .filter((x): x is string => !isNil(x) && isNotEmpty(x))
    .join(' ');
}
